import React, { Fragment } from 'react';

const AboutShuoLicence = () => {
  return (
    <>
      <h1>What is a Shared Housing Unit Operator's License?</h1>
      <p>
        A "Shared Housing Unit Operator" is an owner or operator of more than
        one "shared housing unit".
      </p>
      <p>Shared Housing Unit Operator business license provisions:</p>
      <ul>
        <li>
          Shared Housing Unit Operator must be a natural person; not a business
          entity.
        </li>
        <li>
          Shared Housing Unit Operator License does not guarantee that dwelling
          units are eligible for listing on a licensed platform.
        </li>
      </ul>
      <p>
        As the Shared Housing Operator's License is not a registration, but a
        license, hosts must begin the application process through BACP's online
        licensing system.
      </p>
      <p>
        That system is{' '}
        <a
          target='_blank'
          rel='noreferrer'
          href='https://webapps1.chicago.gov/AccountServices/login.jsp'
        >
          Chicago Business Direct.
        </a>{' '}
        Hosts will not be able to submit Shared Housing Unit Operator's License
        applications through the Shared Housing Registration Portal.
      </p>
    </>
  );
};

export default AboutShuoLicence;
